import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Input, OnChanges, Inject, PACKAGE_ROOT_URL } from '@angular/core';
import { Item, IItem } from '../../models/IItem';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser'
import { S1DataService } from '../../services/s1data.service';
import { RouteDataService } from '../../services/routedata.services';
import { FezaDataService } from '../../services/fezadata.service';
import { FileService } from '../../services/file.service';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { environment } from '../../../environments/environment';
import { BidMode, BidModeList } from "../../enums/bid-mode.enum";
import { IBid } from '../../models/IBid';
import { IBidResponse, BidResponse, ISampleBlendType, ISupplierResponseTypes } from '../../models/IBidResponse'
import { ISample, Sample } from '../../models/ISample';
import { SafeUrl } from '@angular/platform-browser/src/security/dom_sanitization_service';
import { ISupplier, ISupplierMap } from '../../models/ISupplier';
import { QuotaAllocationModeByName } from '../../enums/quota-allocation-mode.enum';
import { ISampleBlend } from '../../models/ISampleBlend';
import { ICurrency } from '../../models/ICurrency';
import { Utils } from '../../Utils';
import { ICostByFieldDuration, ICost, Cost } from '../../models/ICost';
import { ISampleBlendMember } from '../../models/ISampleBlendMember';
import { PanelCheckTargetingModeList, PanelCheckTargetingMode } from '../../enums/panel-check-targeting-mode.enum';
import { ITemplateCriteria } from '../../models/ITemplateCriteria';

@Component({
  selector: 'feasibility-response',
  templateUrl: './feasibility-response.component.html',
  styleUrls: ['../../../assets/css/framework.css',
    './feasibility-response.component.css']
})
export class BidResponseComponent implements OnInit {
  bidId: string;
  bidResponse: IBidResponse;
  bidRequest: IBid;
  feasibilities: Observable<ISample[]>;
  feasibilityList: ISample[];
  

  blends: ISampleBlendType;
  maxBlends: ISampleBlendType;
  originalBlends: ISampleBlendType;
  prePostComBlends: ISampleBlendType;
  suppliers: ISupplierMap;
  selectedRequestSample: ISample;
  downloadJsonHref: SafeUrl;
  showAmpario: boolean;
  fezaIds: Observable<string[]>;
  showBlendButtonByDemand: Map<string, boolean>;
  blendExclusion: Map<string, Map<number, Array<string>>>;
  showSourceKeysByDemand: Map<string, Map<number, string[]>>; //by feza, by supplier, list of duration keys
  blending: boolean;
  sid: string;
  event: string;
  showOnlyTop: boolean;
  showTopCount: number;
  displayCurrency: string;
  bidCurrencies$: Observable<ICurrency[]>;
  reload: boolean;
  showPanelRates: boolean;
  panelRateQuestions: IItem[] = [];
  blendEditMode: boolean;
  fezaIdToName: Map<string, [string, string]>;
  showSuppliers: boolean;
  panelCheckTargetingModeList = PanelCheckTargetingModeList;
  panelCheckTargetingMode: string;

  //let's add a dictionary by feza by supplier to hold costs, and another to figure out if we already showed them or not.
  rateCardList: Map<string, Map<number, ICost>>; //supplier id to a rate card cost
  rateCardListButton: Map<string, Map<number, boolean>>; 


  constructor(private route: ActivatedRoute,
    private s1DataService: S1DataService,
    private routeDataService: RouteDataService,
    private fezaDataService: FezaDataService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private fileService: FileService,
    @Inject(DOCUMENT) private document: any) {
    this.suppliers = {};
    this.feasibilities = Observable.of([]);
    this.blends = new ISampleBlendType;
    this.maxBlends = new ISampleBlendType;
    this.originalBlends = new ISampleBlendType;
    this.prePostComBlends = new ISampleBlendType;
    this.bidResponse = new BidResponse();
    this.showBlendButtonByDemand = new Map<string, boolean>();
    this.showSourceKeysByDemand = new Map<string, Map<number, string[]>>();
    this.blendExclusion = new Map<string, Map<number, Array<string>>>();
    this.rateCardList = new Map<string, Map<number, ICost>>();
    this.rateCardListButton = new Map<string, Map<number, boolean>>();
    this.fezaIdToName = new Map<string, [string, string]>(); //id=>[name,countryCode]
    this.route.queryParams.subscribe(params => {
      this.bidId = params['bidId'];
      this.event = params['event'];
      this.sid = params['sid'];
      this.reload = (params['reload'] == '1');
    });
  }

  ngOnInit() {
    this.showSuppliers = true;
    this.fezaIds = Observable.of([]);
    this.bidCurrencies$ = this.s1DataService.getCurrencies();
    this.routeDataService.routedBidRequestValue.subscribe(bidRequest => {

      if ((bidRequest === null || this.reload == true) && this.bidId != null && this.bidId.length > 0) {
        //console.log("Getting data by bid:" + this.bidId);
        this.fezaDataService.GetResponse(this.bidId, this.displayCurrency).subscribe(bidResponse => {
          this.setup(bidResponse, null);
        });
      }
      else {
        //console.log(`here is bidRequest: ${bidRequest} id:${bidRequest.bidId}`);
        this.routeDataService.routedBidResponseValue.subscribe(bid => this.setup(bid, bidRequest));
      }
    });
  }



  onChangeCurrency(displayCurrency) {
    this.displayCurrency = displayCurrency.code;
    this.fezaIds = Observable.of([]);
    this.bidCurrencies$ = this.s1DataService.getCurrencies();
    this.routeDataService.routedBidRequestValue.subscribe(bidRequest => {

      if (this.bidId != null && this.bidId.length > 0) {
        this.fezaDataService.GetResponse(this.bidId, this.displayCurrency).subscribe(bidResponse => {
          this.setup(bidResponse, null);
        });
      }
    });
  }

  blendMemberSortFn(a: ISampleBlendMember, b: ISampleBlendMember): number {
    //sort by member type, internal, blend percent, then member id desc
    if (a.memberType === b.memberType) {
      if (a.internal === b.internal) {
        if (a.blendPercent === b.blendPercent)
          return a.id - b.id;
        else
          return b.blendPercent - a.blendPercent;
      }
      else
        return a.internal ? -1 : 1;
    }
    else
      return a.memberType == "Supplier" ? 1 : -1;
  }

  getBlendExclusion(fizzyKey: string, supplier: ISupplier): string[] {
    if (this.blendExclusion && this.blendExclusion[fizzyKey] && this.blendExclusion[fizzyKey][supplier.supplierId]) {
      //console.log(`good data:${this.blendExclusion[fizzyKey][supplier.supplierId].join(",")}`);;
      return this.blendExclusion[fizzyKey][supplier.supplierId];
    }
    return [];
  }

  getBlendExclusionClass(exclusion: string): string {
    if ((exclusion || "") == "")
      return "";
    else {
      return (exclusion == "Blend Member") ? "BlendMember" : "NotBlendMember";
    }
  }

  setupBlendExclusions(fizzyKey: string): void {
    var blend = this.blends[fizzyKey] || {} as ISampleBlend;
    this.blendExclusion[fizzyKey] = new Map<number, Array<string>>();

    if (blend.blendTotalQuota && blend.blendTotalQuota.members) {
      for (let s of blend.blendTotalQuota.members) {
        if (s.memberType == "Supplier") {
          this.blendExclusion[fizzyKey][s.id] = [];
          this.blendExclusion[fizzyKey][s.id].push("Blend Member");
        }
      }
    }
    for (let s of (blend.blendExclusions || []))
      this.blendExclusion[fizzyKey][s.supplierId] = [];

    for (let e of (blend.blendExclusions || [])) {
      //return "camelCase" to "Camel Case", or "coveredInternal" to "Covered Internal"
      var blendExclusionStr = e.blendExclusionCode.replace("HighCPI", "HighCpi").replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); })
      this.blendExclusion[fizzyKey][e.supplierId].push(blendExclusionStr);
    }
  }

  sortBlends(fizzyKey: string, blend: ISampleBlendType): void {
    if (blend && blend[fizzyKey] && blend[fizzyKey].blendTotalQuota && blend[fizzyKey].blendTotalQuota.members) {
      blend[fizzyKey].blendTotalQuota.members.sort(this.blendMemberSortFn);
    }
    if (blend && blend[fizzyKey] && blend[fizzyKey].blendTotalQuota && blend[fizzyKey].blendTotalQuota.members) {
      blend[fizzyKey].blendTotalQuota.members.sort(this.blendMemberSortFn);
    }
  }

  setup(resp: IBidResponse, origRequest: IBid) {
    this.fezaIdToName = new Map<string, [string, string]>();
    this.showTopCount = 10;
    this.bidRequest = resp.request != null ? resp.request : origRequest;
    this.downloadJsonHref = "";
    if (resp) {
      this.bidResponse = resp;
      this.blends = this.bidResponse.sampleBlends || {};
      this.maxBlends = this.bidResponse.maxSampleBlends || {};
      for (let fizzy of this.bidRequest.feasibilities) {
        this.sortBlends(fizzy.feasibilityId, this.blends);
        this.sortBlends(fizzy.feasibilityId, this.maxBlends);
        this.updateSupplierResponsesWithBlendCompletes(this.blends, this.bidResponse.feasibilities, fizzy.feasibilityId);
      }
      this.generateDownloadJsonUri();
      
    }
    this.feasibilityList = this.bidRequest.feasibilities;
    this.selectedRequestSample = this.bidRequest.feasibilities[0];
    this.bidId = this.bidRequest.bidId;
    this.setupFeasiblities();
    let [templates, demandsIdsForModifiedBlends] = this.getModifiedTemplateBlendIdsAndLocales();
    let postComSamplesBlendBids = this.getPostCommissiningBlends();
    this.panelCheckTargetingMode = this.bidRequest.panelCheckTargetingMode ? this.bidRequest.panelCheckTargetingMode : this.panelCheckTargetingModeList[PanelCheckTargetingMode.Targeted].name;

    forkJoin(
      this.fezaDataService.CheckSuppliers(this.bidRequest),
      this.fezaDataService.getSampleBlendTemplates(templates),
      this.fezaDataService.getSamplePreCommissioningBlends(this.bidId, postComSamplesBlendBids)
    ).subscribe(data => {
      this.suppliers = data[0];
      for (let item = 0; item < data[1].length; item++) {
        //for modified template blends:
        //map the blends back to the right demands id to show them in the right spot in the UI
        this.originalBlends[demandsIdsForModifiedBlends[item]] = data[2][item];
        this.sortBlends(demandsIdsForModifiedBlends[item], this.originalBlends);
      }
      for (let item = 0; item < data[2].length; item++) {
        //for post com blends that have a pre com blend:
        //map the blends back to the right demands id to show them in the right spot in the UI
        this.prePostComBlends[postComSamplesBlendBids[item]] = data[2][item];
        this.sortBlends(demandsIdsForModifiedBlends[item], this.prePostComBlends);
      }
      this.setupFeasiblities();
    });
  }

  updateSupplierResponsesWithBlendCompletes(blends: ISampleBlendType, feasibilities: ISupplierResponseTypes, feasibilityId: string) {
    
    console.log(blends[feasibilityId]);

    if (!blends || !blends[feasibilityId] || !blends[feasibilityId].blendQuotaLevel || !blends[feasibilityId].blendQuotaLevel.blendQuotaTables) 
      return;

    if (!feasibilities || !feasibilities[feasibilityId])
      return;

    var blendQuotaTables = blends[feasibilityId].blendQuotaLevel.blendQuotaTables.map(x=>x.blendQuotas).reduce((acc, val) => acc.concat(val), []); // flatten the array
    var supplierResponses = feasibilities[feasibilityId];

    console.log(blendQuotaTables);

    for (let supplierResponse of supplierResponses)
    {
      var supplierId = supplierResponse.supplierId;

      for (let qt of supplierResponse.quotaTables)
        for (let quota of qt.quotas){
          var blendQuota = blendQuotaTables.find(b=> b.quotaId == quota.quotaId);  
          if (!blendQuota || !blendQuota.quotaBlendMembers.find(qbm=> qbm.id == supplierId))
            continue;          
          quota.blendCompletes = blendQuota.quotaBlendMembers.find(qbm=> qbm.id == supplierId).numberOfCompletes;
        }      
    }
  }

  getModifiedTemplateBlendIdsAndLocales(): [number[], string[]] {
    let templates: number[] = [];
    let fezaIds: string[] = [];
    for (let s of this.bidRequest.feasibilities) {
      let blend = this.blends[s.feasibilityId];
      if (blend && blend.blendType === "ModifiedTemplateBlend") {
        templates.push(blend.templateBlendId);
        fezaIds.push(s.feasibilityId);
      }
    }
    return [templates, fezaIds];
  }

  getPostCommissiningBlends(): string[] {
    let fezaIds: string[] = [];
    if (this.bidRequest.bidMode === BidModeList[BidMode.Postcommissioning].name)
      for (let s of this.bidRequest.feasibilities) {
        fezaIds.push(s.feasibilityId);
      }
    return fezaIds;
  }

  setupFeasiblities() {
    this.panelRateQuestions = [];
    var panelRateQuestions = new Map<number, IItem>();
    var fezaIds = new Set<string>();//getting a set of feasibilities and fezaIds made
    let feasibilities: ISample[] = [];// more sense when we had multiple demands by feza id... but this will all be replaced with AD so we can leave it here
    this.showBlendButtonByDemand[this.selectedRequestSample.feasibilityId] = this.selectedRequestSample.quotaAllocationMode === 'Balanced';
    this.showSourceKeysByDemand[this.selectedRequestSample.feasibilityId] = new Map<number, string[]>();
    for (let fezaId in this.bidResponse.feasibilities) {
      this.feasibilities[fezaId] = [];
      this.rateCardList[fezaId] = {};
      this.rateCardListButton[fezaId] = {};
      for (let sample of this.bidResponse.feasibilities[fezaId]) {
        var feasabilityFromRequest = this.bidRequest.feasibilities.find(x=>x.feasibilityId == fezaId);
        if (feasabilityFromRequest != null) {
          //new save method doesn't save some redundant properties in responses, so we need to copy them from request feasability
          sample.countryCultures = sample.countryCultures || feasabilityFromRequest.countryCultures;
          sample.lengthOfInterview = feasabilityFromRequest.lengthOfInterview;
          sample.incidenceRatePercent = sample.genPopIncidenceRatePercent || feasabilityFromRequest.incidenceRatePercent; 
          sample.quotaAllocationMode = feasabilityFromRequest.quotaAllocationMode;
          sample.sampleCategoryId = feasabilityFromRequest.sampleCategoryId;
          sample.sampleCategory = feasabilityFromRequest.sampleCategory;
          sample.sampleSubCategoryId = feasabilityFromRequest.sampleSubCategoryId;
          sample.sampleSubCategory = feasabilityFromRequest.sampleSubCategory;
        }
        
        this.rateCardList[fezaId][sample.supplierId] = null;
        this.setupBlendExclusions(fezaId);
        if (fezaId === this.selectedRequestSample.feasibilityId) {
          this.showSourceKeysByDemand[this.selectedRequestSample.feasibilityId][sample.supplierId] = [];
          //setup the "source" ids to download original cache data
          for (var k in sample.sourceSupplierFeasibilityResponseIds)
            this.showSourceKeysByDemand[this.selectedRequestSample.feasibilityId][sample.supplierId].push(k);
          this.showSourceKeysByDemand[this.selectedRequestSample.feasibilityId][sample.supplierId].sort(Utils.sortCompleteLabels);

          //get the panel rates for the unique questions on the sample (target & quota)
          Utils.visitQuestionInSample(this.selectedRequestSample, q => { panelRateQuestions.set(q.id, new Item(q.id, q.name)); });
          this.panelRateQuestions = Array.from(panelRateQuestions.values());//map-> array for easier UI binding.
          feasibilities.push(sample);
        }
      }
    }
    for (let sample of this.bidRequest.feasibilities) {
      this.fezaIdToName[sample.feasibilityId] = [sample.sampleName, sample.countryCode];//for quota viewer, keep track of id->name map
      if (sample.feasibilityId === this.selectedRequestSample.feasibilityId)
        fezaIds.add(sample.feasibilityId);
    }
    this.fezaIds = Observable.of(Array.from(fezaIds.values()));

    this.showOnlyTop = false;
    this.feasibilities = Observable.of(feasibilities);
  }

  onBlendSaved(fezaId: string) {
    //let's just reload everything...
    this.blends[fezaId] = null;
    this.fezaDataService.GetResponse(this.bidId, this.displayCurrency).subscribe(bidResponse => {
      this.setup(bidResponse, null);
    });
  }

  onBypassMongo() {
    console.log("Bypass Mongo");
    //let's just reload everything...
    this.fezaDataService.GetResponse(this.bidId, this.displayCurrency, true).subscribe(bidResponse => {
      this.setup(bidResponse, null);
    });
  }

  getAdhocBlend(fezaId: string) {
    this.blending = true;
    this.fezaDataService.GetAdhocBlend(this.bidResponse, this.bidRequest, fezaId).subscribe(blend => {
      this.fezaDataService.SaveBlend(blend, fezaId, false).subscribe(saved => {
        this.blends[fezaId] = blend;
        this.blending = false;
      },
        err => { this.blending = false; }); //save the new value.
    },
      err => { this.blending = false; });
  }

  quotaAllocationModeLabel(qaName: string) {
    return QuotaAllocationModeByName(qaName).label;
  }

  getSuppliers(fezaId: string, getAmpario: boolean): ISupplier[] {

    var suppliers = (this.suppliers[fezaId] || []).filter(x => !x.isAmpario || getAmpario);

    return suppliers.sort((x, y) => {
      if (x.internal !== y.internal)
        return x.internal ? -1 : 1;

      if (x.isAmpario !== y.isAmpario)
        return x.isAmpario ? 1 : -1;

      if (x.tierCode !== y.tierCode)
        return x.tierCode - y.tierCode;

      if ((x.scoring || 0) !== (y.scoring || 0))
        return (y.scoring || 0) - (x.scoring || 0);

      return 0;
    });

  }

  hasAmpario(fezaId: string): boolean {
    for (var s of this.getSuppliers(fezaId, true)) {
      if (s.isAmpario)
        return true;
    }
    return false;
  }

  onShowAmpario(show: boolean) {
    this.showAmpario = show;
  }

  onShowTop(show: boolean) {
    this.showOnlyTop = show;
  }

  getIdForSupplier(fezaId: string, supplierId: number, addPound: boolean = false): string {
    if (!fezaId || !supplierId)
      return "";
    let dId = fezaId.replace(/-/g, '');
    let append = addPound ? "#" : "";
    return `${append}Item_${dId}_${supplierId}`;
  }

  generateDownloadJsonUri() {
    var theJSON = JSON.stringify(this.bidResponse);
    var uri = this.sanitizer.bypassSecurityTrustUrl("data:text/json;charset=UTF-8," + encodeURIComponent(theJSON));
    this.downloadJsonHref = uri;
  }

  hasSupplierResults(fezaId: string, supplierId: number): boolean {
    if (this.bidResponse.feasibilities[fezaId])
      for (let sample of this.bidResponse.feasibilities[fezaId]) {
        if (sample.supplierId === supplierId)
          return true;
      }
    return false;
  }


  getCostFieldDurations(sample: ISample): string[] {
    return Utils.getCostDurations(sample).filter((x) => sample.costs[x] !== null);
  }

  onAddSupplier(fezaId: string, supplier: ISupplier) {
    let sourceSample: ISample = null;
    for (let key in this.bidResponse.feasibilities) {
      for (let sample of this.bidResponse.feasibilities[key]) {
        if (sourceSample == null || (sourceSample.quotaTables == null && sample.quotaTables != null)) {
          if (sample.quotaTables[0].quotas != null && sample.quotaTables[0].quotas[0].completes) {
            sourceSample = sample;//try to get a long response.  the reason to clone an existing one is to get the duration keys w/o hard coding them
          }
        }
        if (sample.supplierId === supplier.supplierId && sample.feasibilityId === fezaId)
          this.onEditSupplier(sample);
      }
    }
    let clonedSample: ISample = Object.assign(new Sample(), JSON.parse(JSON.stringify(sourceSample || new Sample())));
    clonedSample.supplier = supplier.supplierName;
    clonedSample.supplierId = supplier.supplierId;
    clonedSample.feasibilityId = fezaId;
    clonedSample.costs = {} as ICostByFieldDuration;
    for (let key in clonedSample.supplierTotalCompletes)
      clonedSample.supplierTotalCompletes[key] = 0;
    for (let quotaTable of clonedSample.quotaTables)
      for (let quota of quotaTable.quotas)
        for (let key in quota.completes)
          quota.completes[key] = 0;
    this.bidResponse.feasibilities[fezaId].push(clonedSample);
    this.onEditSupplier(clonedSample);
  }

  onEditSupplier(sample: ISample) {
    sample.numberOfCompletes = this.selectedRequestSample.numberOfCompletes;
    this.routeDataService.routedBidResponseValue = Observable.of(this.bidResponse);
    let url = `/edit?bidId=${this.bidId}&fezaId=${sample.feasibilityId}&supplierId=${sample.supplierId}`;
    if (this.event) url += "&event=" + this.event;
    if (this.sid) url += "&sid=" + this.sid;
    this.router.navigateByUrl(url);
  }

  downloadSupplierFeasibilityCheckLog(sample: ISample) {
    //this.routeDataService.routedBidResponseValue = Observable.of(this.bidResponse);
    let url = `/api/v1/Feasibilities/SupplierFeasibilityCheckLog?bidId=${this.bidId}&feasibilityId=${sample.feasibilityId}&supplierId=${sample.supplierId}`;
    //this.router.navigateByUrl(url);
    this.fileService.downloadSecureFile(environment.fezeUrl + url,
      `Supplier ${sample.supplierId} Raw Info.json`);
  }

  loadRateCard(sample: ISample) {
    console.log(sample);
    
    this.fezaDataService.getRateCardsAllTargets({
      supplierId: sample.supplierId,
      loi: sample.lengthOfInterview,
      incidence: Math.round(sample.genPopIncidenceRatePercent || sample.incidenceRatePercent),
      researchTypeName: sample.researchType,
      countryCode: sample.countryCode,
      languages: sample.countryCultures.join(","),
      sampleCategoryId: sample.sampleCategoryId,
      sampleSubcategoryId: sample.sampleSubCategoryId,
      completes: Number(sample.numberOfCompletes),
      fieldworkDuration: sample.hoursInField
    } as ITemplateCriteria, this.bidRequest.bidCurrency).subscribe(ranges => {

      let cost: ICost = new Cost();
      cost.cpi = 0;
      cost.cpiRanges = Object.assign([], ranges);
      cost.currency = this.bidRequest.bidCurrency;
      this.rateCardList[sample.feasibilityId][sample.supplierId] = cost;
      this.rateCardListButton[sample.feasibilityId][sample.supplierId] = true;
    }, err => {
        this.rateCardListButton[sample.feasibilityId][sample.supplierId] = true;
    });

  }

  downloadSupplierFeasibilityData(sample: ISample) {
    console.log(`logging: ${sample.supplierId} record:${sample.supplierFeasibilityResponseId}`)
    let url = `/api/v1/Feasibilities/SupplierFeasibilityData?supplierId=${sample.supplierId}&supplierFeasibilityResponseId=${sample.supplierFeasibilityResponseId}&`;
    this.fileService.downloadSecureFile(environment.fezeUrl + url, `Supplier ${sample.supplierId} Data.json`);
  }

  downloadSupplierFeasibilitySource(sample: ISample, fieldDuration: string) {
    var sourceId = sample.sourceSupplierFeasibilityResponseIds[fieldDuration];
    console.log(`logging: ${sample.supplierId} record:${sourceId}`)
    let url = `/api/v1/Feasibilities/SupplierFeasibilityData?supplierId=${sample.supplierId}&supplierFeasibilityResponseId=${sourceId}&`;
    this.fileService.downloadSecureFile(environment.fezeUrl + url, `Supplier ${sample.supplierId} Source Data ${fieldDuration}.json`);
  }

  onSaveSupplierInfo(bidId: string, fezaId: string, supplierId: number) {
    this.fileService.downloadSecureFile(environment.fezeUrl + `/api/v2/Feasibilities/SupplierExcel?bidId=${bidId}&feasibilityId=${fezaId}&supplierId=${supplierId}`,
      `Supplier ${supplierId} results.xlsx`);
  }

  showMinFee(supplier: ISupplier): number {
    if (supplier.supplierFees !== undefined) {
      return this.selectedRequestSample.feasibilityCheckEnabled === true && supplier.apiIntegrated ?
        supplier.supplierFees.surveyAPIMinFeeEvaluated
        : supplier.supplierFees.surveyNONAPIMinFeeEvaluated;
    }
    return null;
  }

  showSetupFee(supplier: ISupplier): number {
    if (supplier.supplierFees !== undefined) {
      return this.selectedRequestSample.feasibilityCheckEnabled === true && supplier.apiIntegrated ?
        supplier.supplierFees.surveyAPISetupFeeEvaluated
        : supplier.supplierFees.surveyNONAPISetupFeeEvaluated;
    }
    return null;
  }


  setupFeeLabel(supplier: ISupplier) {
    var fee = Utils.toTwo(this.showSetupFee(supplier) || 0);
    var formula = supplier.supplierFees.surveyAPISetupFee != "" ? supplier.supplierFees.surveyAPISetupFee : null;
    var level = supplier.supplierFees.setupFeeLevel != "" ? `(${supplier.supplierFees.setupFeeLevel})` : null;
    var currency = this.showFeeCurrency(supplier);
    return `${formula || fee} ${currency} ${level}`;
  }

  minFeeLabel(supplier: ISupplier) {
    var fee = Utils.toTwo(this.showMinFee(supplier) || 0);
    var formula = supplier.supplierFees.surveyAPIMinFee != "" ? supplier.supplierFees.surveyAPIMinFee : null;
    var level = supplier.supplierFees.minFeeLevel != "" ? `(${supplier.supplierFees.minFeeLevel})` : null;
    var currency = this.showFeeCurrency(supplier);
    return `${formula || fee} ${currency} ${level}`;
  }


  showAdditionalInfo(supplier: ISupplier): string {
    if (supplier.supplierFees !== undefined)
      return supplier.supplierFees.additionalInfo;
    else
      return null;
  }

  showFeeCurrency(supplier: ISupplier): string {
    if (supplier.supplierFees !== undefined)
      return supplier.supplierFees.currency;
    else
      return null;
  }

  onBidEdit() {
    let url = `/request?bidId=${this.bidId}`;
    if (this.event) url += "&event=" + this.event;
    if (this.sid) url += "&sid=" + this.sid;
    this.router.navigateByUrl(url);
  }


  padRight(text: string, padChar: string, size: number): string {
    return (text.trim() + String(padChar).repeat(size)).substr(0, size);
  }

  mailTo(bidId: string, fezaId: string, supplier: ISupplier, email: string, name: string) {
    this.fezaDataService.SendSupplierEmail(bidId, fezaId, supplier.supplierId, email, name).subscribe(body => {
      let mailto = `mailto:${email}?subject=${encodeURIComponent("Request for sample!")}&body=${encodeURIComponent(body.substring(0, 1900))}`;
      //console.log(`mail to is ${mailto.length} chars...`);
      //console.log(mailto);
      this.document.location.href = mailto;
    });
  }

  GenerateFeasabilitySupplierEmail(bidId: string, fezaId: string, supplier: ISupplier, exportAllFesabilitiesForSupplier: boolean) {
    this.fezaDataService.SupplierFeasibilitiesEmail(bidId, fezaId, supplier.supplierId, exportAllFesabilitiesForSupplier).subscribe(body => {
      if (body === true)
        alert("An email has been sent to your inbox");
      else
        alert("There was an error sending the email");
    });
  }

  displayCapacitySource(capacitySource: string, internal: boolean, feasibilityModeCode: string) {
    if (internal) return "Internal";
    if (capacitySource === "07-Uncovered") return "";
    for (let capacity of this.fezaDataService.GetCapacitySources())
      if (capacity["code"] === capacitySource) {
        if (feasibilityModeCode === "01-NOBLEND" && capacitySource === "01-FeAPI")
          return "(testing) " + capacity["title"];
        else
          return capacity["title"];
      }
    return "";
  }

  getCapacitySources() {
    return this.fezaDataService.GetCapacitySources();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/feasibility-response/feasibility-response.component.ts